import { HelpButton } from './HelpButton';
import type { HelpButtonProps } from './HelpButton';
import { HelpButtonContentHeader } from './HelpButtonContentHeader';

// Object.assign is used for the right typing.
// Based on this solution: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
const _HelpButton = Object.assign(HelpButton, {
  ContentHeader: HelpButtonContentHeader,
});

export { _HelpButton as HelpButton, HelpButtonProps };
